// src/App.jsx
import React from 'react';
import { BrowserRouter as Router, Routes, Route, Navigate } from 'react-router-dom';

import Sidebar from './components/Sidebar';
import ICVForm from './pages/ICVForm';
import RelatorioICV from './pages/RelatorioICV';
import Plano30Dias from './pages/Plano30Dias'; // <- novo

function App() {
  return (
    <Router>
      <div style={{ display: 'flex', minHeight: '100vh', width: '100%' }}>
        <Sidebar />

        {/* Área principal */}
        <div
          style={{
            flex: 1,
            padding: '24px',
            overflowY: 'auto',
            background: '#f7f9fc'
          }}
        >
          <Routes>
            {/* Formulário */}
            <Route path="/" element={<ICVForm />} />
            <Route path="/icv" element={<ICVForm />} />

            {/* Relatório */}
            <Route path="/relatorio-icv" element={<RelatorioICV />} />

            {/* Plano de 30 dias */}
            <Route path="/plano-30-dias" element={<Plano30Dias />} />

            {/* Fallback */}
            <Route path="*" element={<Navigate to="/icv" replace />} />
          </Routes>
        </div>
      </div>
    </Router>
  );
}

export default App;
